import React, { Fragment } from 'react';
import HealthInformationForm from './HealthInformationForm';
import AppointmentHeader from '../Components/AppointmentHeader';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import useNavigateToPreviousPage from '../hooks/useNavigateToPreviousPage';

function AppointmentHealthInformation() {
  usePageView('Get Care | Health Information');

  const { navigateToPrevPage } = useNavigateToPreviousPage();

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.health" />
      <AppointmentHeader
        title="profile.section.health"
        handleBack={navigateToPrevPage}
      />
      <HealthInformationForm />
    </Fragment>
  );
}

export default AppointmentHealthInformation;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentHealthInformation/index.jsx